import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import ListArticlesComponent from './list-articles.component';

let ListArticlesModule = angular
  .module('ListArticles', [
    uiRouter
  ])
  .component('listArticles', ListArticlesComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('listArticles', {
      url: '/list-articles',
      data: {
        authRequired: true,
        permsRequired: ['products-list']
      },
      views: {
        'menu': 'menu',
        'content': {
          component: 'listArticles',
          bindings: { articlesObservable: 'articlesObservable' }
        }
      },
      resolve: {
        articlesObservable: (ContentService) => ContentService.getArticlesList()
      }
    })
  })
  .name;

export default ListArticlesModule;


// WEBPACK FOOTER //
// ./src/app/pages/list-articles/list-articles.module.js